import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import TusgaiZuvshuurul from '../views/tusgaizuvshuurul'
import SBG from '../views/surgaltiinBvrtgeliinGerchilgee'
import surgaltiinBaiguullaga from '../views/surgaltiinBaiguullaga'
import surgaltiinOrchin from '../views/surgaltiinOrchin'
import tetgeleg from '../views/Tetgeleg'
import statistic from '../views/statistic'
import statisticCategory from '../views/statisticCategory'
import mbsut from '../views/mbsut'
import niigmiinTvnshlel from '../views/niigmiinTvnshlel'
import bagsh_hvnii_nuuts from '../views/bagsh_hvnii_nuuts'
import laws from '../views/laws'
import news from '../views/news/news'
import newsDetails from '../views/news/news_details'
import surgaltiinTuv from '../views/section/surgaltiinTuv'


Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
    {
      path: '/tusgai',
      name: 'TusgaiZuvshuurul',
      component: TusgaiZuvshuurul
    },
    {
      path: '/SBG',
      name: 'SBG',
      component: SBG
    },
    {
      path: '/sur',
      name: 'surgaltiinBaiguullaga',
      component: surgaltiinBaiguullaga
    },
    {
      path: '/s_tuv',
      name: 'surgaltiinTuv',
      component: surgaltiinTuv
    },
    {
      path: '/orchin',
      name: 'surgaltiinOrchin',
      component: surgaltiinOrchin
    },
    {
      path: '/tetgeleg',
      name: 'tetgeleg',
      component: tetgeleg
    },
    {
      path: '/statistic/:torol_id',
      name: 'statistic',
      component: statistic
    },
    {
      path: '/statistic_cat',
      name: 'statisticCategory',
      component: statisticCategory
    },
    {
      path: '/mbsut',
      name: 'mbsut',
      component: mbsut
    },
    {
      path: '/tvnshlel',
      name: 'niigmiinTvnshlel',
      component: niigmiinTvnshlel
    },
    {
      path: '/hvnii_nuuts',
      name: 'bagsh_hvnii_nuuts',
      component: bagsh_hvnii_nuuts
    },
    {
      path: '/law/:category_id',
      name: 'laws',
      component: laws
    },
    {
      path: '/news',
      name: 'news',
      component: news
    },
    {
      path: '/newsDetails/:id',
      name: 'newsDetails',
      component: newsDetails
    },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }

]


const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
});

export default router
